import styles from './ChordChip.module.css';

export type ChordChipState = 'default' | 'selected' | 'muted';

interface ChordChipProps {
  chordId: string;
  state?: ChordChipState;
  chromatic?: boolean;
  onClick?: () => void;
}

export function ChordChip({ chordId, state = 'default', chromatic = false, onClick }: ChordChipProps) {
  const muted = state === 'muted';
  const selected = state === 'selected';
  return (
    <button
      type="button"
      className={[styles.chip, selected && styles.selected, muted && styles.muted, chromatic && styles.chromatic]
        .filter(Boolean)
        .join(' ')}
      onClick={muted ? undefined : onClick}
      aria-pressed={selected}
      aria-disabled={muted || undefined}
      aria-label={chromatic ? `${chordId} (borrowed)` : chordId}
    >
      {chordId}
    </button>
  );
}
